import { Injectable } from '@angular/core';
import {
  Configuration,
  FunctionDesc,
  CustomDialogAction
} from '../../../models/configuration.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import * as config from '../../../../assets/config.json';
import { Map } from '../../../models/objects.model';
import { SetupService } from '../setup/setup.service';

// TODO MK-REF
// TODO Rozrzucić dane po odpowiednich usługach
@Injectable()
export class DataStoreService {
  private currentNode: Subject<FunctionDesc>;
  public currentNodeObject: FunctionDesc = null;
  private configuration: Configuration = null;
  private showGrid: Subject<boolean>;
  private customSingleViewContent: Subject<string>;
  private customDialogSingleViewContent: Subject<CustomDialogAction>;

  public currentElementId = '';
  public currentElementViewId = '';
  public currentId = '';
  public currentViewName = '';
  public currentObjectId = '';

  public currentRowData: BehaviorSubject<Map[]>;
  public currentRowDataObject: Map[];
  public currentRowFunctions: FunctionDesc[] = [];

  public apiUrl: string;

  public singleViewElementId: string;
  public singleViewGenericElementViewId: string;
  public singleViewId: string;

  public isAuth: any;
  public errorId: BehaviorSubject<number>;

  constructor(
    private setup: SetupService,
  ) {
    this.currentNode = new Subject<FunctionDesc>();
    this.showGrid = new Subject<boolean>();
    this.customSingleViewContent = new Subject<string>();
    this.customDialogSingleViewContent = new Subject<CustomDialogAction>();
    this.errorId = new BehaviorSubject<number>(0);
    this.currentViewName = '';
    this.currentRowData = new BehaviorSubject<Map[]>(null);
    this.currentRowFunctions = [];
    this.currentRowDataObject = [];
    this.apiUrl = this.setup.baseUrl;
  }

  public getCurrentView(): Observable<FunctionDesc> {
    return this.currentNode.asObservable();
  }

  public setCurrentView(view: FunctionDesc): void {
    this.currentNodeObject = view;
    this.currentNode.next(view);
  }

  getErrorId(): Observable<number> {
    return this.errorId;
  }

  public setErrorId(id: number): void {
    this.errorId.next(id);
  }

  public setConfiguration(configuration: Configuration): void {
    this.configuration = configuration;
  }

  public getConfiguration(): Configuration {
    return this.configuration;
  }

  public setShowGrid(visible: boolean): void {
    this.showGrid.next(visible);
  }

  public getShowGrid(): Observable<boolean> {
    return this.showGrid.asObservable();
  }

  public setCustomSingleViewContent(data: string): void {
    this.customSingleViewContent.next(data);
  }

  public getCustomSingleViewContent(): Observable<string> {
    return this.customSingleViewContent.asObservable();
  }

  public setCustomDialogSingleViewContent(data: CustomDialogAction): void {
    this.customDialogSingleViewContent.next(data);
  }

  public getCustomDialogSingleViewContent(): Observable<CustomDialogAction> {
    return this.customDialogSingleViewContent.asObservable();
  }

  public setCurrentRowData(rowData: Map[]): void {
    this.currentRowDataObject = rowData;
    this.currentRowData.next(rowData);
  }

  public getCurrentRowData(): Observable<Map[]> {
    return this.currentRowData.asObservable();
  }

  public refreshNode() {
    this.setCurrentView(this.currentNodeObject);
  }

  public sortFunction(obj: FunctionDesc[]): FunctionDesc[] {
    obj.forEach(function(e) {
      e = this.sortObject(e.functions);
      if (e.functions != null && e.functions.length > 0) {
        obj.forEach(function(g) {
          g = this.sortObject(g.functions);
        }, this);
      }
    }, this);
    return obj;
  }

  private sortObject(obj: FunctionDesc[]): FunctionDesc[] {
    obj.sort(function(a, b) {
      const keyA = a.order,
        keyB = b.order;
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/data-store/data-store.service.ts